export const SET_MP_ID = 'SET_MP_ID';
export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const SET_LOADABLE_PROJECT = 'SET_LOADABLE_PROJECT';
export const SET_LOADABLE_PRODUCT_SHAPES = 'SET_LOADABLE_PRODUCT_SHAPES';
export const SET_LOADABLE_BASE_OFFER = 'SET_LOADABLE_BASE_OFFER';
export const SET_LOADABLE_PRICING_CONTEXT = 'SET_LOADABLE_PRICING_CONTEXT';
export const SET_LOADABLE_UPSELL_PRICE_BY_SKU = 'SET_LOADABLE_UPSELL_PRICE_BY_SKU';
export const SET_LOADABLE_PRODUCT_SPECS_BY_SKU = 'SET_LOADABLE_PRODUCT_SPECS_BY_SKU';
